/* eslint-disable quotes */
export function sideSlider() {
    $(".inner-slider").slick({
        arrows: true,
        prevArrow: "<button class='prev white-arrow'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",   
        nextArrow:"<button class='next white-arrow'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
        dots: true,
        slidesToShow: 1,
    });
}
export function awardsSlider() {
    
    $(".awards-slider").slick({
        arrows: true ,
        prevArrow: "<button class='prev ocean-prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",   
        nextArrow:"<button class='next ocean-right'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
        dots: false,
        mobileFirst: true,
        slidesToShow: 2,
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 5,
                    
                }
            }

        ],
    });
    $(".awards-slider").on('beforeChange', function (e, slick, currentSlide, nextSlide) {
        $(this).find('.prev').prop('disabled', nextSlide === slick.slideCount - 1);
    });
}

export function testimonialsSlider() {

    $('.testimonials-slider').slick({
        prevArrow: "<button class='prev'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.24625 0L0.24625 6L6.24625 12L7.75 10.5L3.24625 6L7.75 1.5L6.24625 0Z' fill='white'/></svg></button>",   
        nextArrow: "<button class='next'><svg width='8' height='12' viewBox='0 0 8 12' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M1.75375 0L7.75375 6L1.75375 12L0.25 10.5L4.75375 6L0.25 1.5L1.75375 0Z' fill='white'/></svg></button>",
        arrows: true,
        mobileFirst: true,
        slidesToShow: 1,
        dots: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1279,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/slider.js